import { MainThunkDispatch, State } from "../../Reducers"
import { BillingAPIType } from "../Types"
import { successMessage, failMessage } from "../Client/MessagesActions"
import { APIBillingAddressModel } from "../../Models/API/BillingModel"
import { safePromise } from "../../Helpers/Functions/promise"
import { apiFetch } from "../Client/NetworkActions"
import { apiEndpoints } from "../../Routes/api"
import { segmentIdentity } from "../../Helpers/Functions/analytics"

export const getInvoiceList = () => async (dispatch: MainThunkDispatch) => {
    const endpoint = apiEndpoints.getInvoiceList({})
    const { error, data } = await safePromise(
        dispatch(apiFetch("GET_INVOICES", endpoint))
    )

    if (error !== undefined || data === undefined) {
        return
    }

    dispatch({
        type: BillingAPIType.invoices_setList,
        payload: {
            invoiceList: data.invoices
        }
    })
}

export const getPaymentMethodsList =
    () => async (dispatch: MainThunkDispatch) => {
        const endpoint = apiEndpoints.getPaymentMethodList({})
        const { error, data } = await safePromise(
            dispatch(apiFetch("GET_PAYMENT_METHODS", endpoint))
        )

        if (error !== undefined || data === undefined) {
            return
        }

        dispatch({
            type: BillingAPIType.paymentMethod_setList,
            payload: {
                paymentMethodList: data.paymentMethods
            }
        })
    }

export const registerStripePaymentMethod =
    (
        last4Digits: string,
        tokenId: string,
        address: APIBillingAddressModel,
        priority: number
    ) =>
    async (
        dispatch: MainThunkDispatch,
        getState: () => State
    ): Promise<boolean> => {
        const endpoint = apiEndpoints.createPaymentMethod({})
        const { error } = await safePromise(
            dispatch(
                apiFetch("CREATE_PAYMENT_METHOD", endpoint, {
                    method: "POST",
                    body: JSON.stringify({
                        name: last4Digits,
                        priority,
                        token: tokenId,
                        provider: "STRIPE",
                        address
                    })
                })
            )
        )

        if (error !== undefined) {
            dispatch(failMessage("Could not register payment info"))
            return false
        }

        dispatch(successMessage("Registered successfully"))

        await getPaymentMethodsList()

        segmentIdentity(getState())

        return true
    }

export const deletePaymentMethod =
    (methodID: number) => async (dispatch: MainThunkDispatch) => {
        const endpoint = apiEndpoints.deletePaymentMethod({
            methodID
        })
        const { error } = await safePromise(
            dispatch(
                apiFetch(`DELETE_PAYMENT_METHOD_${methodID}`, endpoint, {
                    method: "DELETE"
                })
            )
        )

        if (error !== undefined) {
            dispatch(failMessage("Could not delete payment info"))
            return
        }

        dispatch(successMessage("Delete successfully"))

        await dispatch(getPaymentMethodsList())
    }
